import { render, staticRenderFns } from "./DocumentCapture.vue?vue&type=template&id=879a7bae"
import script from "./DocumentCapture.vue?vue&type=script&lang=js"
export * from "./DocumentCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports